import * as React from 'react';
import { app, pages } from "@microsoft/teams-js";

export class MeetingExtensibilityConfiguration extends React.Component<{}, {}> {
    constructor(props: any) {
        super(props);
    }

    public componentDidMount() {
        app.initialize();

        pages.config.registerOnSaveHandler(function (saveEvent) {
            pages.config.setConfig({
                entityId: "Balcão Virtual",
                contentUrl: `${window.location.origin}/in-meeting-panel`,
                suggestedDisplayName: "Balcão Virtual",
            });
            saveEvent.notifySuccess();
        });
        pages.config.setValidityState(true);
    }

    public render() {
        return (
            <React.Fragment>
                Favor clicar em salvar para começar.
            </React.Fragment>
        );
    }
}